import { Box, Button, Grid2, InputLabel, TextField, Typography, useMediaQuery, useTheme } from "@mui/material"
import './forgotpassword.css'
import MUIButton from "../../reusable_components/components/MUIButton"
import MUICancelButton from "../../reusable_components/components/MuiCancelButton"
import ORLogo from '../../assets/ORhorizontal.svg'
import *  as Yup from 'yup'
import { yupResolver } from "@hookform/resolvers/yup"
import { Controller, useForm } from "react-hook-form"
import { Link, useNavigate } from "react-router-dom"
import { useForgetPasswordMutation, useForgotOtpPasswordMutation } from "../../redux/login/login.api"
import { useContext, useState } from "react"
import { SnackbarContext } from "../../reusable_components/components/Snackbar"
import Loader from "../../reusable_components/components/Loader";


const ForgotPassword = () => {

    const theme = useTheme()
    const navigate = useNavigate()
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'))
    const { Snackbar } = useContext(SnackbarContext)

    const validationSchema = Yup.object().shape({
        email: Yup.string().email("Enter Valid Email").required("Please Enter the email")
            .test('Enter Valid Email', 'Enter Valid Email', (value) => {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                return emailRegex.test(value);
            }),
    })

    const resolver = yupResolver(validationSchema)

    const {
        control,
        handleSubmit,
        formState: { errors }
    } = useForm({
        mode: 'onChange',
        resolver,
        defaultValues: {
            email: ""
        }
    })

    const [forgetPassword] = useForgotOtpPasswordMutation()

    const [otpExpiryTime, setOptExpiryTime] = useState("")
    const [loader , setLoader]=useState(false)

    const onSubmit = async (data) => {
        try {
            const payload = {
                emailId: data?.email
            }

            setLoader(true)
            const response = await forgetPassword(payload).unwrap()
            setLoader(false)
            if (response?.response?.status === 'success') {
                Snackbar(response?.response?.message, 'success')
                setOptExpiryTime(response?.userDetails?.map((data)=>data?.otpExpiryTime))
                navigate('/forgetPassword-screen' , {
                    state:{
                        email:data?.email , response:response, resetCount: true
                    }
                })
                localStorage.clear('resetHandled')
            } else {
                Snackbar(response?.response?.message, 'error')
            }
        } catch (err) {
            Snackbar('Network error', 'error')
        }
    }

    

    return (
        <Box className="screencontainer">
            {loader ? <Loader/> :''}
            <Grid2 sx={{ position: 'absolute', top: 30, left: 50 }}>
                <img src={ORLogo} alt="Logo" style={{ width: "30%", height: '30%' }}></img>
            </Grid2>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Grid2 sx={{ display: 'flex' }}>
                    <Grid2>
                        <Grid2 container item sx={{ display: "flex", flexDirection: "column", width: '410px', border: "1px solid", borderColor: '#D5D7DA', padding: '20px', borderRadius: '10px' }} rowGap={2}>
                            <Grid2 sx={{ display: 'flex', flexDirection: 'column' }} rowGap={1}>
                                <Typography sx={{ fontWeight: 600, fontSize: '28px', color: '#181D27' }}> Forgot Password</Typography>
                                <Typography variant="body2" sx={{ color: '#535862', fontSize: '12.5px' }}>Enter Your Email Address</Typography>
                                <Typography variant="body2" sx={{ color: '#535862', fontSize: '12.5px' }}>We'll send you a new password so can get back into your account</Typography>
                            </Grid2>
                            <Grid2 item>
                                <InputLabel className="inputlabels">Email <span style={{ color: 'red' }}>*</span></InputLabel>
                                <Controller
                                    control={control}
                                    name={"email"}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            size="small"
                                            placeholder="Enter your email"
                                            className="mailtextfield"
                                            autoComplete="off"
                                            sx={{
                                                "& .MuiFormHelperText-root": {
                                                    color: "red",
                                                }
                                            }}
                                            helperText={errors?.email ? errors?.email?.message : ""}
                                        />
                                    )}
                                />
                            </Grid2>
                            <Button variant="contained" className="loginButton" type="submit"> Submit </Button>
                            <Typography component={Link} to='/'>Click here to login</Typography>
                        </Grid2>
                        <Typography sx={{ textAlign: 'center', fontSize: '14px', }}>Copyright @ Open Recruiter</Typography>
                    </Grid2>
                    {/* <Typography className="text" >Candidate? <span style={{ color: "#0073B1", cursor: "pointer" }} onClick={handleRegisterNav}>Register</span> </Typography> */}
                </Grid2>
            </form>
        </Box>
    )
}

export default ForgotPassword